// extracted by mini-css-extract-plugin
export default {"root":"Navigation_root__ekcWW","inline":"Navigation_inline__QiFQC","outlined":"Navigation_outlined__PgQGc"};